import React, { forwardRef } from 'react'

import { FormControlLabel, Radio as MuiRadio } from '@material-ui/core'
import { RadioProps } from './RadioProps'

export const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  const { disabled, LabelProps, ...muiProps } = props
  const label = LabelProps?.label || props.label
  const control = <MuiRadio disabled={label ? undefined : disabled} {...muiProps} />
  return label ? (
    <FormControlLabel disabled={disabled} inputRef={ref} control={control} {...LabelProps} label={label} />
  ) : (
    control
  )
})

Radio.displayName = 'Radio'
